var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70269 3.95825C2.88164 3.95825 1.41108 5.42344 1.29014 7.25877L1.16526 9.15397C1.07457 10.5303 1.8969 11.8033 3.18879 12.2864L8.75935 14.3699C9.5594 14.6691 10.4406 14.6691 11.2407 14.3699L16.8113 12.2864C18.1031 11.8033 18.9255 10.5303 18.8348 9.15397L18.7099 7.25878C18.589 5.42344 17.1184 3.95825 15.2974 3.95825H4.70269Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54167 11.25C8.54167 10.9048 8.82149 10.625 9.16667 10.625H10.8333C11.1785 10.625 11.4583 10.9048 11.4583 11.25C11.4583 11.5952 11.1785 11.875 10.8333 11.875H9.16667C8.82149 11.875 8.54167 11.5952 8.54167 11.25Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.84901 11.3189C2.19235 11.7457 2.64969 12.0849 3.18879 12.2865L8.75935 14.3699C9.5594 14.6691 10.4406 14.6691 11.2407 14.3699L16.8112 12.2865C17.3504 12.0849 17.8077 11.7457 18.1511 11.3188L18.3572 14.7901C18.478 16.825 16.8603 18.5416 14.8217 18.5416H5.17835C3.1398 18.5416 1.52208 16.825 1.64291 14.7901L1.84901 11.3189Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.89988 3.5144C8.14691 3.02034 8.65188 2.70825 9.20426 2.70825H10.7958C11.3482 2.70825 11.8531 3.02034 12.1002 3.5144L12.3221 3.95825H13.7196L13.2182 2.95538C12.7594 2.03784 11.8216 1.45825 10.7958 1.45825H9.20426C8.17842 1.45825 7.24062 2.03784 6.78185 2.95538L6.28041 3.95825H7.67796L7.89988 3.5144Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsIcon);
export default __webpack_public_path__ + "static/media/ProductsIcon.c0921d4b5e14ba341ed8c7fae4038005.svg";
export { ForwardRef as ReactComponent };